import { QrAssets } from '../models/qrAssets';
import { QrAssetsEntity } from './qrAssetsEntity';

export const QrAssetsListValueObject = (data: QrAssets[]) => {
  return Object.freeze({
    list: data.map(item => QrAssetsEntity(item))
  });
}